<template>
  <div class="rating">
    <img v-for="({ src }, index) in stars" :key="index" :src="src" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import filled from '../assets/star-favorite-fill.svg';
import stroked from '../assets/star-favorite-stroke.svg';

const props = defineProps<{ rating: number }>();

const maxRating = [1, 2, 3, 4, 5];

const stars = computed(() => maxRating.map((x) => ({ src: x <= props.rating ? filled : stroked })));
</script>

<style scoped>
.rating {
  display: flex;
  align-items: center;
  /* gap: 4px; */
  margin: auto 0 8px auto;
}
</style>
